import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { SearchRequestModelDashboard, SearchRequestModel } from 'src/app/shared/models/request/search-request-model';
import { AppointmentCountForDashboardResponseModel, AppointmentCountForTodaysDashboardResponseModel, NotScheduledCallCountResponseModel,NotScheduledCallCountResponseModel2, TherapistDashboardStatisticsModel, TodaysScheduledAppointmentDashboardResponseModel } from 'src/app/shared/models/response/appointment/appointments-counts-response-model';
import { NoOfCallResponseModel } from 'src/app/shared/models/response/report-summary-response-model';
import { WipStatus } from 'src/app/shared/models/common/wip-status';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends BaseService {

  constructor(httpService: HttpClient, webStorageService: WebStorageService) {
    super(httpService, webStorageService);
  }

  getCountFacilities() {
    return this.get<ResultOfT<number>>('Dashboard/GetCountFacilities');
  }

  GetCountTotalTherapists() {
    return this.get<ResultOfT<number>>('Dashboard/GetCountTotalTherapists');
  }

  getCountDoctors() {
    return this.get<ResultOfT<number>>('Dashboard/GetCountDoctors');
  }

  getCountCSOperators() {
    return this.get<ResultOfT<number>>('Dashboard/GetCountCSOperators');
  }

  GetCountNotScheduledTelehealthCalls(branchId: number) {
    return this.get<ResultOfT<NotScheduledCallCountResponseModel>>('Dashboard/GetCountNotScheduledTelehealthCalls/' + branchId);
  }

  GetPotentialVoid(branchid: number, isRefresh: boolean, userid: string) {
    if (!isRefresh)
      return this.get<ResultOfT<NotScheduledCallCountResponseModel>>('Dashboard/GetPotentialVoid?branchid=' + branchid + '&userid=' + userid);
    else {
      var randomNum = this.webStorageService.getRandomNumber();
      return this.get<ResultOfT<NotScheduledCallCountResponseModel>>('Dashboard/GetPotentialVoid?branchid=' + branchid + '&userid=' + userid + '&rnd=' + randomNum);
    }
  }

  getCountOpenAppointment(branchid: number, isRefresh: boolean, userid: string) {
    if (!isRefresh)
      return this.get<ResultOfT<AppointmentCountForDashboardResponseModel>>('Dashboard/GetCountOpenAppointment?branchid=' + branchid + '&userid=' + userid);
    else {
      var randomNum = this.webStorageService.getRandomNumber();
      return this.get<ResultOfT<AppointmentCountForDashboardResponseModel>>('Dashboard/GetCountOpenAppointment?branchid=' + branchid + '&userid=' + userid + '&rnd=' + randomNum);
    }
  }

  getCountNoShowAppointment(branchid: number, isRefresh: boolean, userid: string) {
    if (!isRefresh)
      return this.get<ResultOfT<AppointmentCountForDashboardResponseModel>>('Dashboard/GetCountNoShowSalesOrder?branchid=' + branchid + '&userid=' + userid);
    else {
      var randomNum = this.webStorageService.getRandomNumber();
      return this.get<ResultOfT<AppointmentCountForDashboardResponseModel>>('Dashboard/GetCountNoShowSalesOrder?branchid=' + branchid + '&userid=' + userid + '&rnd=' + randomNum);
    }
  }

  getCountTherapists(searchRequest: SearchRequestModelDashboard) {
    return this.post<ResultOfT<number>>('Dashboard/GetCountTherapists', searchRequest);
  }

  getCountTherapistsLisenceExpired(searchRequest: SearchRequestModelDashboard) {
    return this.post<ResultOfT<number>>('Dashboard/GetCountTherapistsLisenceExpired', searchRequest);
  }

  getUnReconciledAppointments(branchid: number, isRefresh: boolean, userid: string) {
    if (!isRefresh)
      return this.get<ResultOfT<AppointmentCountForDashboardResponseModel>>('Dashboard/GetUnReconciledAppointments?branchId=' + branchid + '&userid=' + userid);
    else {
      var randomNum = this.webStorageService.getRandomNumber();
      return this.get<ResultOfT<AppointmentCountForDashboardResponseModel>>('Dashboard/GetUnReconciledAppointments?branchId=' + branchid + '&userid=' + userid + '&rnd=' + randomNum);
    }
  }

  GetCountNotScheduledCalls(branchid: number, isRefresh: boolean, userid: string) {
    if (!isRefresh)
      return this.get<ResultOfT<NotScheduledCallCountResponseModel2>>('Dashboard/GetCountNotScheduledCalls?branchId=' + branchid + '&userid=' + userid);
    else {
      var randomNum = this.webStorageService.getRandomNumber();
      return this.get<ResultOfT<NotScheduledCallCountResponseModel2>>('Dashboard/GetCountNotScheduledCalls?branchId=' + branchid + '&userid=' + userid + '&rnd=' + randomNum);
    }
  }

  GetUrgentCallBackRequestCount(branchid: number, isRefresh: boolean, userid: string) {
    if (!isRefresh)
      return this.get<ResultOfT<NotScheduledCallCountResponseModel>>('Dashboard/GetUrgentCallBackRequestCount?branchId=' + branchid + '&userid=' + userid);
    else {
      var randomNum = this.webStorageService.getRandomNumber();
      return this.get<ResultOfT<NotScheduledCallCountResponseModel>>('Dashboard/GetUrgentCallBackRequestCount?branchId=' + branchid + '&userid=' + userid + '&rnd=' + randomNum);
    }
  }

  GetTherapistDashboardStatistics(branchid: number, isRefresh: boolean) {
    if (!isRefresh)
      return this.get<ResultOfT<TherapistDashboardStatisticsModel>>('Dashboard/GetTherapistDashboardStatistics?branchId=' + branchid);
    else {
      var randomNum = this.webStorageService.getRandomNumber();
      return this.get<ResultOfT<TherapistDashboardStatisticsModel>>('Dashboard/GetTherapistDashboardStatistics?branchId=' + branchid + '&rnd=' + randomNum);
    }
  }

  getStatus() {
    return this.get<ResultOfT<WipStatus[]>>('Appointment/GetDashboardWipStates');
  }

  getCountCancelSalesOrder(branchid: number, isRefresh: boolean, userid: string) {
    if (!isRefresh)
      return this.get<ResultOfT<AppointmentCountForDashboardResponseModel>>('Dashboard/GetCountCancelSalesOrder?branchId=' + branchid + '&userid=' + userid);
    else {
      var randomNum = this.webStorageService.getRandomNumber();
      return this.get<ResultOfT<AppointmentCountForDashboardResponseModel>>('Dashboard/GetCountCancelSalesOrder?branchId=' + branchid + '&userid=' + userid + '&rnd=' + randomNum);
    }
  }

  GetTodaysDashboardCount(isRefresh: boolean, userid: string, filterdDate: string,branchid: number) {
    if (!isRefresh)
      return this.get<ResultOfT<AppointmentCountForTodaysDashboardResponseModel>>('Dashboard/GetTodaysDashboardCount?userid=' + userid + '&filterdDate=' + filterdDate + '&branchId=' + branchid);
    else {
      var randomNum = this.webStorageService.getRandomNumber();
      return this.get<ResultOfT<AppointmentCountForTodaysDashboardResponseModel>>('Dashboard/GetTodaysDashboardCount?userid=' + userid + '&filterdDate=' + filterdDate + '&branchId=' + branchid + '&rnd=' + randomNum);
    }
  }

  GetTodaysScheduleAppointmentDashboardCount(isRefresh: boolean, userid: string, filterdDate: string,branchid: number) {
    if (!isRefresh)
      return this.get<ResultOfT<TodaysScheduledAppointmentDashboardResponseModel>>('Dashboard/GetTodaysScheduleAppointmentDashboardCount?userid=' + userid + '&filterdDate=' + filterdDate + '&branchId=' + branchid);
    else {
      var randomNum = this.webStorageService.getRandomNumber();
      return this.get<ResultOfT<TodaysScheduledAppointmentDashboardResponseModel>>('Dashboard/GetTodaysScheduleAppointmentDashboardCount?userid=' + userid + '&filterdDate=' + filterdDate + '&branchId=' + branchid + '&rnd=' + randomNum);
    }
  }
}
